var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.459,
    height: 19.707,
    viewBox: "0 0 18.459 19.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ee048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63cc5d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_secure",
    transform: "translate(-276.789 -186.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-secure-5150931",
    d: "M138.464,39.855v-.506h0a.7.7,0,0,0-.618-.7,12.681,12.681,0,0,1-4-1.341,15.778,15.778,0,0,1-4.037-2.689.7.7,0,0,0-.948,0,15.786,15.786,0,0,1-4.031,2.71,12.68,12.68,0,0,1-4,1.341.7.7,0,0,0-.618.7v.506a13.012,13.012,0,0,0,2.268,9.058,15.387,15.387,0,0,0,6.622,5.154.7.7,0,0,0,.527,0,15.384,15.384,0,0,0,6.621-5.154,13.012,13.012,0,0,0,2.219-9.079Zm-5.849,3.511L129.1,46.877a.7.7,0,0,1-.99,0l-2.107-2.107a.7.7,0,0,1,.99-.99l1.636,1.622,3.012-3.012a.7.7,0,0,1,.99.99Z",
    transform: "translate(156.678 152.214)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecure);
export default __webpack_public_path__ + "static/media/ic_secure.8b6af3a3b493183edddafc1f1e758fd8.svg";
export { ForwardRef as ReactComponent };